module.exports = __webpack_public_path__ + "static/background-a197adc1c695afd0e565f74d7680e583.jpg";